var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"main"},[_c('div',{staticClass:"content"},[_vm._t("default")],2),(_vm.$slots.sidebar)?_c('aside',{staticClass:"sidebar"},[_c('div',{staticClass:"sidebar__block"},[_vm._t("sidebar")],2)]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }